<button class="__button" type="button">
  <span></span>
  <span></span>
  <span></span>
</button>
